import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

import { EActions, EPaths } from '@enums/redux.enum';

import rootReducer from './rootReducer';

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: [EActions.PERSIST, EActions.REHYDRATE, EActions.REGISTER],
				ignoredPaths: [EPaths.register, EPaths.rehydrate],
			},
		}),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
